import { prop, path, sortBy } from 'ramda';

const dateSorting = (selector: ReturnType<typeof prop | typeof path>, items) => sortBy(selector, items);

export default dateSorting;
